import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const BusinessManagementTabsBox = styled(Box)
    .withConfig({ displayName: 'BusinessManagementTabs' })
    .attrs({
        pb: 2,
    })``;
